<script lang="ts">
    import type { NavigationToolManager } from "./NavigationToolManager";

    export let manager: NavigationToolManager;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div on:click={() => manager.zoomIn()} class="toolbox-button">
    <svg
        class="toolbox-icon"
        viewBox="0 0 20 20"
        id="iD-icon-plus"
        xmlns="http://www.w3.org/2000/svg"
        ><path
            d="M10 3.75c.69 0 1.25.56 1.25 1.25v3.75H15a1.25 1.25 0 010 2.5h-3.75V15a1.25 1.25 0 01-2.5 0v-3.75H5a1.25 1.25 0 010-2.5h3.75V5c0-.69.56-1.25 1.25-1.25z"
        /></svg
    >
</div>
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div on:click={() => manager.zoomOut()} class="toolbox-button">
    <svg
        class="toolbox-icon"
        viewBox="0 0 20 20"
        id="iD-icon-minus"
        xmlns="http://www.w3.org/2000/svg"
        ><path
            d="M15 8.75a1.25 1.25 0 010 2.5H5a1.25 1.25 0 010-2.5h10z"
        /></svg
    >
</div>

<style>
    .toolbox-button {
        width: 40px;
        height: 40px;
    }

    .toolbox-icon {
        margin-left: 10px;
        margin-top: 10px;
        width: 20px;
        height: 20px;
    }

    svg path {
        fill: #fff;
    }
</style>
